import React from 'react';
import { Select, TextInput } from '@mantine/core';
import './HelpHeader.css';
import ImageOverShape from '../../../components/ImageOverShape/ImageOverShape';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import { useConfigContext } from '../../../contexts/ConfigContext/ConfigContextProvider';

const HelpHeader = ({ onSearchChange, onThemeSearch, themes  }) => {

   const { jsonTexts, jsonMedia } = useConfigContext()
   const texts = jsonTexts?.ayuda

  const {width} = useWindowDimensions();
  const isTablet = width < 1000;
  const isMobile = width < 768;

  const handleThemeChange = (selectedTheme) => {
    onThemeSearch(selectedTheme);
  };
  return (
    <>
    <div className={`helpHeader-father-div ${isTablet ? 'helpHeader-father-div-tablet' : ''}`}>
      <div className='helpHeader-titles-div'>
        <h2 className='helpHeader-title'>{texts?.title}</h2>
        <h4 className='helpHeader-subtitle'>{texts?.subtitle}</h4>
      </div>
      {!isTablet && <div className='helpHeader-image'>
        <ImageOverShape left="0px" square height={160} imageUrl={jsonMedia.helpHero} backgroundColor='var(--color-secondary)' />
      </div>}
      
      <div className={`helpHeader-selector ${isMobile ? 'helpHeader-selector-mobile' : ''}`}>
        <TextInput
          placeholder={texts?.textInputPlaceholder}
          onChange={(event) => onSearchChange(event.target.value)}
        />
        <Select placeholder={texts?.selectInputPlaceholder} onChange={handleThemeChange} data={themes.map(theme => ({ label: theme, value: theme }))}/>
      </div>
    </div>
    </>
  );
};

export default HelpHeader;
